/**
 * Show or hide loading indicator (useful for http requests or long running task)
 * @param show boolean
 */
export const loading = async (show = false) => {
  // await dynamic import
  await import('@app/components/loader/cc-loader.component')

  let loader = document.body.querySelector('cc-loader')

  // If loader does not exist in DOM and create loader and append to body
  if (!loader) {
    loader = document.createElement('cc-loader')
    document.body.appendChild(loader)
  }

  // set loader state
  loader.active = show
}
